(function () {
  class FreeSpinsIntro extends PIXI.Container {
    constructor() {
      super();

      this._callback = undefined;

      this.visible = false;

      this._spinsWon = undefined;

      this._pressStartBox = undefined;
    }

    ///////////////////////////////////////////////
    initialise() {
      const self = this;

      messageBus.subscribe("spinner:GameConfigEvent", function () {
        self.onLayoutComplete();
      });
    }

    ///////////////////////////////////////////////
    onLayoutComplete() {
      this._spinsWon = resourceManager.get(
        "featurePopupContainer:freespinsIntroPopup:FreeSpinsIntro:youWon"
      );

      this._pressStartBox = resourceManager.get(
        "featurePopupContainer:freespinsIntroPopup:FreeSpinsIntro:pressStartColourBox"
      );

      this._pressStartBox.interactive = false;

      resourceManager.get(
        "featurePopupContainer:freespinsIntroPopup:FreeSpinsIntro"
      ).visible = true;
    }

    ///////////////////////////////////////////////
    setup() {
      resourceManager.get(
        "featurePopupContainer:freespinsIntroPopup:FreeSpinsIntro"
      ).visible = true;

      // wait for click - anywhere on screen
      this._pressStartBox.interactive = true;
      this._pressStartBox.mousedown = this._pressStartBox.touchstart =
        this.closeDialog.bind(this);
    }

    ///////////////////////////////////////////////
    showIntro(numFS, callback) {
      this.setup();

      this._callback = callback;

      this._spinsWon.setTranslationParameters(numFS);

      gameData.musicManager.fadeOutAllMusic();
      gameData.musicManager.fadeInPopUpMusic();
    }

    ///////////////////////////////////////////////
    closeDialog() {
      //let reels = resourceManager.get("slotContainer:reelContainer");
      //reels.alpha = 1.0;

      // turn off click processing
      this._pressStartBox.interactive = false;
      this._pressStartBox.mousedown = this._pressStartBox.touchstart =
        undefined;

      gameData.musicManager.fadeOutPopUpMusic();

      resourceManager.get(
        "featurePopupContainer:freespinsIntroPopup:FreeSpinsIntro"
      ).visible = false;
      this._callback();
    }
  }

  ///////////////////////////////////////////////
  let freeSpinsIntroCreator = function (json) {
    return new FreeSpinsIntro();
  };

  ///////////////////////////////////////////////
  let freeSpinsIntroInitialiser = function (json, disclaimer) {
    disclaimer.initialise();
  };

  ///////////////////////////////////////////////
  let freeSpinsIntroFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "FreeSpinsIntro",
    freeSpinsIntroCreator,
    freeSpinsIntroInitialiser,
    freeSpinsIntroFilesRequired
  );
})();
